import { TAnalyticsUser } from '../../../types/analytics';
import { IApplicationState } from '../../../types/redux';

export function createUserTrackingData(state: IApplicationState): TAnalyticsUser {
  const { userData } = state;

  if (!userData) {
    return {};
  }

  return {
    userId: userData.realtyUserId,
  };
}
